// extracted by mini-css-extract-plugin
module.exports = {"menu-modal":"MenuOptionsModal_menu-modal__36zW5","option":"MenuOptionsModal_option__1zH9s","disabled":"MenuOptionsModal_disabled__1BrcA"};